import { render, staticRenderFns } from "./UpdateOrderStatus.vue?vue&type=template&id=2f54da84&scoped=true&"
import script from "./UpdateOrderStatus.vue?vue&type=script&lang=js&"
export * from "./UpdateOrderStatus.vue?vue&type=script&lang=js&"
import style0 from "./UpdateOrderStatus.vue?vue&type=style&index=0&id=2f54da84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f54da84",
  null
  
)

export default component.exports